module.exports = __webpack_public_path__ + "media/images/common/arrow_2-aca73780839fbeceea429c38114cb354.gif";